import { CourseCard } from 'pages/CoursesPage/components/CreateCourse/components/CourseCard/CourseCard';
import s from './ViewCourses.module.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CourseCardMini } from 'pages/CoursesPage/components/CreateCourse/components/CourseCardMini/CourseCardMini';
import { DropdownBlock } from 'components/DropdownBlock/DropdownBlock';
import { useState } from 'react';
import questionMark from "assets/images/questionMark.webp";
import {ReactComponent as DeleteIcon} from "assets/icons/delete_icon3.svg";
import {ReactComponent as ArrowTools} from "assets/icons/arrow_tools.svg";
import { ModalGeneral } from 'components/Modals/ModalGeneral';
import { useDeleteCoursesFromSectionMutation } from '../../../../redux/apis/sectionApi';
import { useStatusContext } from 'components/StatusProvider';
import {ReactComponent as EditIcon} from "assets/icons/edit_icon.svg";
const URL = process.env.REACT_APP_API_ADDRESS

export const ViewCourses = ({courses, tags, section, refetch, setShowModalCourses}: any) => {

    // ### State
     const [showDeleteCoursesModal, setShowDeleteCoursesModal] = useState<any>(false);
    const {i18n, t} = useTranslation()
    const langs = useSelector((store: any) => store.main.langs);
       const { openStatus } = useStatusContext();

    const [DeleteCourses, {isLoading: isDeleteCoursesLoading}] = useDeleteCoursesFromSectionMutation()

    // ### Effects
    const [show, setShow] = useState<boolean>(false)

    // ### Functions

    async function handleDeleteCourses(){
        const response = await DeleteCourses({sectionId: section})
        if(response.data.message === "updated"){
            openStatus('success', "status.operationSuccessful");
            refetch()
        }
    }

    // ### Views
    const coursesView = courses?.map((course: any, index: number) => {
        const image = Object.entries(course?.image)?.reduce((acc: any, el: any) => {
            if(el[0] === "default_image" || el[0] === "isManual"){
                acc[el[0]] = el[1]
            }else{
                acc[el[0]] = `${URL}${el[1]}`
            }
            return acc
        },{})
        return(
            <div className={s.item} key={index}>
                <CourseCardMini 
                    id={course.id}
                    image={image}
                    title={course?.active_card_name ? course?.card_name?.[i18n.language] : course.name?.[i18n.language]}
                /> 
            </div>  
        )
    })

    const tagsView = tags?.map((tag: any, index: number) => (
        <span key={index} className={s.tag}>{`${tag}${index+1 === tags?.length ? "" : ","}`}</span>
    ))

    return(
        <div className={s.wrapper}>
            <p className={s.title} onClick={() => setShow(!show)}>{t('courses.courses')}</p>
            <div className={s.tools}>
                <div className={`${s.arrow} ${show ? s.active_arrow : ''}`} onClick={() => setShow(!show)}><ArrowTools/></div>
                <div className={s.edit} onClick={()=>{setShowModalCourses(section)}}><EditIcon/></div>
                <div className={s.delete} onClick={()=>setShowDeleteCoursesModal(true)}><DeleteIcon/></div>
            </div>
            <DropdownBlock open={show}>
                <div className={s.content}>
                    <div className={s.tags}>
                        <span className={s.title}>Tags: </span>{tagsView}
                    </div>
                    <div className={s.courses}>
                        {coursesView}
                    </div>
                </div>
            </DropdownBlock>

            <ModalGeneral
                showModal={showDeleteCoursesModal}
                setShowModal={setShowDeleteCoursesModal}
                image={questionMark}
                buttonRight={handleDeleteCourses}
                title={t("general.delete")}
                textLeftButton={t("general.cancel")}
                textRightButton={t("general.delete")}
                description={`${t("general.areYouSure")}? ${t("general.itsContents")}`}
            />

        </div>
    )
}